import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../BonusBunniesSoundConfig";

/**
 * Created by Jerker Nord on 2019-10-25.
 */

export class BonusBunniesBonusSpinsCounterView extends BaseView {

    private _extraReelActivated:boolean = false;
    private _bonusSpinsCounters:PIXI.spine.Spine[];
    private _counterContainer:PIXI.Container;
    private _meterBackground:PIXI.Sprite;
    private _isRestore:boolean = false;
    private _initCounterNumber:number = 3;
    private static METER_BACKGROUND_LANDSCAPE_POSITION:PIXI.Point = new PIXI.Point(48, -54);
    private static METER_BACKGROUND_PORTRAIT_POSITION:PIXI.Point = new PIXI.Point(-56, -49);
    private static COUNTER_CONTAINER_LANDSCAPE_POSITION:PIXI.Point = new PIXI.Point(-16, 120);
    private static COUNTER_CONTAINER_PORTRAIT_POSITION:PIXI.Point = new PIXI.Point(86, 14);
    private static VERTCIAL_PADDING:number = -14;
    private static HORIZONTAL_PADDING:number = -14;
    private _layer:ScalableLayer;
    private _orientation:string;
    private _initAnimationsComplete:boolean = false;

    constructor() {
        super();
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
        this._layer.addChild(this);
    }

    protected initAnimations():void {
        this._counterContainer = new PIXI.Container();
        this._counterContainer.visible = false;
        this.addChild(this._counterContainer);
        this._meterBackground = new PIXI.Sprite(GameResources.getTextures("meter_board")[0]);
        this._counterContainer.addChild(this._meterBackground);
        this._bonusSpinsCounters = [];
        const bonusSpinsCounter01:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("bonusSpinCounter"));
        this._counterContainer.addChild(bonusSpinsCounter01);
        this._bonusSpinsCounters.push(bonusSpinsCounter01);
        const bonusSpinsCounter02:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("bonusSpinCounter"));
        this._counterContainer.addChild(bonusSpinsCounter02);
        this._bonusSpinsCounters.push(bonusSpinsCounter02);
        const bonusSpinsCounter03:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("bonusSpinCounter"));
        this._counterContainer.addChild(bonusSpinsCounter03);
        this._bonusSpinsCounters.push(bonusSpinsCounter03);

        this._initAnimationsComplete = true;

        if(this._isRestore == true) {
            this.checkRestore();
        }
    }

    private checkRestore():void {
        if(this._isRestore == true && this._initAnimationsComplete == true) {
            this._isRestore = false;
        }
    }

    protected onResize(resizeData:IResizeData):void {
        this._orientation = resizeData.orientation;
        if(resizeData.orientation == Orientation.LANDSCAPE) {
            this.setLandscapePosition();
        } else {
            this.setPortraitPosition();
        }
    }

    private setPortraitPosition():void {
        this._counterContainer.position = BonusBunniesBonusSpinsCounterView.COUNTER_CONTAINER_PORTRAIT_POSITION;
        this._meterBackground.rotation = 0;
        this._meterBackground.position = BonusBunniesBonusSpinsCounterView.METER_BACKGROUND_PORTRAIT_POSITION;
        for(let i:number = 1; i < this._bonusSpinsCounters.length; i++) {
            this._bonusSpinsCounters[i].position.y = 0;
            this._bonusSpinsCounters[i].position.x = (this._bonusSpinsCounters[i].width * i) + (BonusBunniesBonusSpinsCounterView.HORIZONTAL_PADDING * i);
        }
    }

    private setLandscapePosition():void {
        this._counterContainer.position = BonusBunniesBonusSpinsCounterView.COUNTER_CONTAINER_LANDSCAPE_POSITION;
        this._meterBackground.rotation = 90 * PIXI.DEG_TO_RAD;
        this._meterBackground.position = BonusBunniesBonusSpinsCounterView.METER_BACKGROUND_LANDSCAPE_POSITION;
        for(let i:number = 1; i < this._bonusSpinsCounters.length; i++) {
            this._bonusSpinsCounters[i].position.x = 0;
            this._bonusSpinsCounters[i].position.y = (this._bonusSpinsCounters[i].height * i) + (BonusBunniesBonusSpinsCounterView.VERTCIAL_PADDING * i);
        }
    }

    public fillUpMeter(from:number):void {
        if(from < 1) {
            from = 1;
        }
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_FILL_METER);
        for(let i:number = from - 1; i < this._bonusSpinsCounters.length; i++) {
            this._bonusSpinsCounters[i].state.clearTracks();
            this._bonusSpinsCounters[i].skeleton.setToSetupPose();
            this._bonusSpinsCounters[i].state.setAnimation(0, "add", false);
        }
    }

    public setState(bounsSpinsLeft:number):void {
        if(this._counterContainer.visible == true) {
            if(bounsSpinsLeft == 3) {
                this._bonusSpinsCounters[bounsSpinsLeft - 1].state.setAnimation(0, "minus", false);
            }
            if(bounsSpinsLeft == 2) {
                this._bonusSpinsCounters[bounsSpinsLeft - 1].state.setAnimation(0, "minus", false);
            }
            if(bounsSpinsLeft == 1) {
                this._bonusSpinsCounters[bounsSpinsLeft - 1].state.setAnimation(0, "minus", false);
                this._bonusSpinsCounters[bounsSpinsLeft - 1].state.setAnimation(1, "lastspin", true);
            }
        }
    }

    public initBonusSpinsCounter():void {
        if(this._orientation == Orientation.LANDSCAPE) {
            this.setLandscapePosition();
        } else {
            this.setPortraitPosition();
        }
        this._counterContainer.visible = true;

        for(let i:number = 0; i < this._bonusSpinsCounters.length; i++) {
            this._bonusSpinsCounters[i].state.clearTracks();
            this._bonusSpinsCounters[i].skeleton.setSkin(null);
            this._bonusSpinsCounters[i].skeleton.setSkinByName((i + 1).toString());
            this._bonusSpinsCounters[i].skeleton.setSlotsToSetupPose();
            if(i < this._initCounterNumber) {
                this._bonusSpinsCounters[i].state.setAnimation(0, "filled", true);
            } else {
                this._bonusSpinsCounters[i].state.setAnimation(0, "minus", false);
            }
        }
    }

    public hideBonusSpinsCounter():void {
        this._counterContainer.visible = false;
    }

    set extraReelActivated(value:boolean) {
        this._extraReelActivated = value;
    }

    set isRestore(value:boolean) {
        this._isRestore = value;
        this.checkRestore();
    }

    set initCounterNumber(value:number) {
        this._initCounterNumber = value;
    }
}